/**
 * Application configuration from environment variables
 * This file centralizes all configuration values
 */

// Tenant Detection — extract subdomain from the current hostname
// e.g., brights.renttick.com → "brights", dev1.brights.renttick.com → "brights"
const ENV_PREFIXES = ['dev1', 'dev2', 'staging'];

function detectTenantSubdomain() {
  // Build-time override always wins (set in .env.dev1, .env.production, etc.)
  if (process.env.REACT_APP_TENANT_SUBDOMAIN) {
    return process.env.REACT_APP_TENANT_SUBDOMAIN;
  }

  const hostname = window.location.hostname;

  // Local development: no auto-detection
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null;
  }

  // Extract tenant from *.renttick.com
  // dev1.brights.renttick.com → ["dev1", "brights", "renttick", "com"] → "brights"
  // brights.renttick.com      → ["brights", "renttick", "com"]        → "brights"
  // dev1.renttick.com         → ["dev1", "renttick", "com"]           → null (no tenant)
  const parts = hostname.split('.');
  if (parts.length >= 3 && parts.slice(-2).join('.') === 'renttick.com') {
    // 4+ parts: env.tenant.renttick.com → tenant is second-to-last before renttick.com
    if (parts.length >= 4) {
      return parts[parts.length - 3];
    }
    // 3 parts: either "brights.renttick.com" (tenant) or "dev1.renttick.com" (env only)
    if (ENV_PREFIXES.includes(parts[0])) {
      return null;
    }
    return parts[0];
  }

  return null;
}

// Resolved tenant subdomain for the current session
export const TENANT_SUBDOMAIN = detectTenantSubdomain();

// Application Information
export const APP_CONFIG = {
  name: process.env.REACT_APP_NAME || 'RentTick',
  version: process.env.REACT_APP_VERSION || '1.0.0',
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
};

// API Configuration
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 120000, // 2 minutes default
};

// Feature Flags
export const FEATURES = {
  enableDebug: process.env.REACT_APP_ENABLE_DEBUG === 'true',
  enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
};

// UI Configuration
export const UI_CONFIG = {
  itemsPerPage: parseInt(process.env.REACT_APP_ITEMS_PER_PAGE) || 10,
  theme: process.env.REACT_APP_THEME || 'light',
};

// Development logging
if (FEATURES.enableDebug) {
  console.log('🔧 Application Configuration:', {
    app: APP_CONFIG,
    api: API_CONFIG,
    features: FEATURES,
    ui: UI_CONFIG,
    tenant: TENANT_SUBDOMAIN,
  });
}

export default {
  APP_CONFIG,
  API_CONFIG,
  FEATURES,
  UI_CONFIG,
  TENANT_SUBDOMAIN,
};
